import { HiCamera, HiStar } from "react-icons/hi2";
import { Order } from "../../__generated__/graphql";

export default function OrderNotice({ order }: { order: Order }): JSX.Element {
  if (!order || order.orderStatus === "") return <></>;

  switch (order.orderStatus) {
    // 예약팩
    case "예약팩-주문대기-픽업대기":
      return (
        <p className="text-3xl font-medium break-keep text-white text-center">
          팩이 확정될 때까지 기다려주세요!
        </p>
      );
    case "예약팩-주문확정-픽업대기":
      return (
        <div className="text-center space-y-3">
          <p className="text-3xl font-medium break-keep text-white text-center">
            <span className="font-black tracking-wider underline underline-offset-4">
              꼭 픽업시간에 맞춰
            </span>{" "}
            픽업을 해주세요!
          </p>

          <div className="flex flex-col gap-1">
            <p className="text-xl text-white font-medium">
              만약{" "}
              <span className="font-black tracking-wider">조기확정 알림</span>을
              받았다면
            </p>
            <p className="text-xl text-white font-medium">
              지금부터 픽업이 가능해요!
            </p>
          </div>
        </div>
      );
    case "예약팩-주문확정-픽업가능":
      return (
        <div className="text-center space-y-3">
          <p className="text-3xl font-medium break-keep text-white text-center">
            지금은{" "}
            <span className="text-success font-black tracking-wider underline underline-offset-4">
              픽업이 가능한 시간
            </span>
            이에요!
          </p>
          <div className="flex flex-col gap-1">
            <p className="text-xl text-white font-medium flex items-center justify-center gap-2">
              <HiCamera className="text-2xl" />
              픽업 후 바로 사진 남기기!
            </p>
          </div>
        </div>
      );
    case "예약팩-주문확정-픽업완료":
      return (
        <div className="text-center space-y-3">
          <p className="text-3xl font-medium break-keep text-white text-center">
            마히팩은 어땠나요?
          </p>
          <div className="flex flex-col gap-1">
            <p className="text-xl text-white font-medium flex items-center justify-center gap-2">
              <HiCamera className="text-2xl" />
              포토리뷰를 작성해주시면{" "}
            </p>
            <p className="text-xl text-white font-medium flex items-center justify-center gap-2">
              <HiStar className="text-2xl font-black tracking-wider underline underline-offset-4" />{" "}
              스탬프를 드려요!
            </p>
            <p className="text-sm text-white/90 font-medium">
              (구매 확정 후 2일 이내 포토리뷰 작성 시)
            </p>
          </div>
        </div>
      );
    case "예약팩-주문취소-픽업취소":
      // 사장님이 취소했을 경우
      if (order.canceledBy === "seller") {
        return (
          <div className="text-center space-y-3">
            <p className="text-3xl font-medium break-keep text-white text-center">
              아쉽지만, 주문이{" "}
              <span className="font-black tracking-wider underline underline-offset-4">
                취소
              </span>
              되었어요.
            </p>
            <div className="flex flex-col gap-1">
              <p className="text-xl text-white font-medium">
                히어로님, 다음에 다시 도전해봐요!
              </p>
              <p className="text-xl text-white font-medium break-keep">
                환불은 영업일 기준 1-2일 내에 완료돼요.
              </p>
            </div>
          </div>
        );
      } else {
        return (
          <div className="text-center space-y-3">
            <p className="text-3xl font-medium break-keep text-white text-center">
              주문이{" "}
              <span className="font-black tracking-wider underline underline-offset-4">
                취소
              </span>
              되었어요.
            </p>
            <p className="text-xl text-white font-medium break-keep">
              환불은 영업일 기준 1-2일 내에 완료돼요!
            </p>
          </div>
        );
      }

    // 실시간팩
    case "실시간팩-주문확정-픽업완료":
      return (
        <div className="text-center space-y-3">
          <p className="text-3xl font-medium break-keep text-white text-center">
            마히팩은 어땠나요?
          </p>
          <div className="flex flex-col gap-1">
            <p className="text-xl text-white font-medium flex items-center justify-center gap-2">
              <HiCamera className="text-2xl" />
              포토리뷰를 작성해주시면{" "}
            </p>
            <p className="text-xl text-white font-medium flex items-center justify-center gap-2">
              <HiStar className="text-2xl font-black tracking-wider underline underline-offset-4" />{" "}
              스탬프를 드려요!
            </p>
            <p className="text-sm text-white/90 font-medium">
              (구매 확정 후 2일 이내 포토리뷰 작성 시)
            </p>
          </div>
        </div>
      );
    case "실시간팩-주문확정-픽업대기":
      return (
        <div className="text-center space-y-3">
          <p className="text-3xl font-medium break-keep text-white text-center">
            <span className="font-black tracking-wider underline underline-offset-4">
              꼭 픽업시간에 맞춰
            </span>{" "}
            픽업을 해주세요!
          </p>
          <p className="text-lg text-white font-black break-keep">
            픽업 시간은 사장님과 약속한 시간이에요.
          </p>
          <div className="flex flex-col gap-1">
            <p className="text-xl text-white font-medium flex items-center justify-center gap-2">
              <HiCamera className="text-2xl" />
              픽업 후 바로 사진 남기기!
            </p>
          </div>
        </div>
      );
    case "실시간팩-주문취소-픽업취소":
      return (
        <div className="text-center space-y-3">
          <p className="text-3xl font-medium break-keep text-white text-center">
            주문이{" "}
            <span className="font-black tracking-wider underline underline-offset-4">
              취소
            </span>
            되었어요.
          </p>
          <p className="text-xl text-white font-medium break-keep">
            환불은 영업일 기준 1-2일 내에 완료돼요.
          </p>
        </div>
      );
    default:
      return <></>;
  }
}
